export const SUPPORTED_LOCALES = ["en", "fr"] as const;
export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = "en";

export function normalizeLocale(input: string): AppLocale {
  const base = input.toLowerCase().split("-")[0]; // "fr-FR" -> "fr"
  return (SUPPORTED_LOCALES as readonly string[]).includes(base)
    ? (base as AppLocale)
    : DEFAULT_LOCALE;
}

export function detectBrowserLocale(): AppLocale {
  return normalizeLocale(navigator.language || DEFAULT_LOCALE);
}
